import { IYoelloTheme } from "../../../../../../yoello-lib/modules/themes/IYoelloTheme";
import { createStyles, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: IYoelloTheme) =>
  createStyles({
    userStatusContainer: {
      maxWidth: "600px",
      width: "500px",
    },
    searchUser: {
      border: "solid 1px #E8EAF4",
      marginBottom: "2rem",
      borderRadius: "12px",
      padding: "0",
      margin: "0",
      "& .header": {
        display: "flex",
        alignItems: "center",
        borderBottom: "solid 1px #E8EAF4",
        padding: "1rem",
        height: "4rem",

        "& .clearButtonContainer": {
          textAlign: "right",
          "& >button": {
            borderRadius: 50,
            fontWeight: "400",
            fontSize: "13px",
          },
        },
      },
      "& .formContainer": {
        padding: "2rem 1rem",
        "& .searchButton": {
          background: "#FFFCE6",
          border: "1px solid #FFDD02 !important",
          boxSizing: "border-box",
          borderRadius: "7px",
          padding: "8px",
          cursor: "pointer",
        },
      },
    },
    userStatusDetails: {
      "& .status": {
        display: "flex",
        flexDirection: "column",
        "& >p": {
          display: "flex",
          flexDirection: "row",
          marginBottom: ".5rem",
          alignItems: "center",
        },
      },
      "& .date": {
        "& >p": {
          display: "flex",
          flexDirection: "row",
          marginBottom: ".5rem",
        },
      },
      "& .userStatusBox": {
        width: "fit-content",
        height: "3.125rem",
        background: "#F3DCE3",
        opacity: "0.8",
        borderRadius: "8px",
        padding: "0.75rem 0.75rem 0.75rem 1.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "& >p": {
          margin: 0,
          fontFamily: "Open Sans",
          fontStyle: "normal",
          fontWeight: 600,
          fontSize: "0.9375rem",
          lineHeight: "1.25rem",
          paddingRight: "1rem",
        },
      },
    },
  })
);
